import { Picture } from 'ui-kit/picture'
import ImageMob1x from './image-mob1x.png'
import ImageMob2x from './image-mob2x.png'
import ImageDesk1x from './image-desk1x.png'
import ImageDesk2x from './image-desk2x.png'
import clsx from 'clsx'
import classes from './ConnectorFramework.module.scss'

export const ConnectorFramework = ({ className }: { className?: string }) => {
  return (
    <Picture
      mobSrc1x={ImageMob1x.src}
      mobSrc2x={ImageMob2x.src}
      deskSrc1x={ImageDesk1x.src}
      deskSrc2x={ImageDesk2x.src}
      className={clsx(classes.image, className)}
      alt='ConnectorFramework'
      lazyLoad
    />
  )
}
